
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a7oaJ", function(module, exports) {

$parcel$export(module.exports, "loadPlannerDraft", () => $75dd4eed55130d28$export$afc61dac49205150);
$parcel$export(module.exports, "savePlannerDraft", () => $75dd4eed55130d28$export$1fcd7530e4b55e27);
$parcel$export(module.exports, "clearPlannerDraft", () => $75dd4eed55130d28$export$f895c61c7541ddef);
const $75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY = 'financial_planner_draft_v1';
function $75dd4eed55130d28$export$afc61dac49205150() {
    try {
        const raw = localStorage.getItem($75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || !parsed.data) return null;
        return parsed;
    } catch (error) {
        return null;
    }
}
function $75dd4eed55130d28$export$1fcd7530e4b55e27(data, step, substepIndex) {
    try {
        localStorage.setItem($75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY, JSON.stringify({
            data: data,
            step: step,
            substepIndex: substepIndex,
            updatedAt: Date.now()
        }));
    } catch (error) {
    // Storage pieno o disabilitato: il planner continua a funzionare senza bozza
    }
}
function $75dd4eed55130d28$export$f895c61c7541ddef() {
    try {
        localStorage.removeItem($75dd4eed55130d28$var$FINANCIAL_PLANNER_DRAFT_KEY);
    } catch (error) {
    // ignore
    }
}

});


var $a7oaJ = parcelRequire("a7oaJ");
const $a972bfa91f3ae789$var$desktopMediaQuery = window.matchMedia("(min-width: 1025px)");
function $a972bfa91f3ae789$var$setupPillarCarousel(root) {
    const viewport = root.querySelector("[data-carousel-viewport]");
    const section = root.closest(".finance-section");
    const prevButton = section?.querySelector("[data-carousel-prev]");
    const nextButton = section?.querySelector("[data-carousel-next]");
    const dotsRoot = root.querySelector("[data-carousel-dots]");
    const cards = Array.from(viewport?.querySelectorAll(".finance-pillar-card") ?? []);
    if (!viewport || !prevButton || !nextButton || !dotsRoot || cards.length === 0) return;
    const dots = cards.map((_, index)=>{
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "finance-carousel-dot";
        dot.setAttribute("aria-label", `Vai allo strumento ${index + 1}`);
        dot.addEventListener("click", ()=>{
            const targetCard = cards[index];
            if (!targetCard) return;
            viewport.scrollTo({
                left: targetCard.offsetLeft,
                behavior: "smooth"
            });
        });
        dotsRoot.appendChild(dot);
        return dot;
    });
    const updateActiveDot = ()=>{
        const currentScroll = viewport.scrollLeft;
        let activeIndex = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;
        cards.forEach((card, index)=>{
            const distance = Math.abs(card.offsetLeft - currentScroll);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                activeIndex = index;
            }
        });
        dots.forEach((dot, index)=>{
            dot.classList.toggle("is-active", index === activeIndex);
            dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
        });
    };
    const updateButtons = ()=>{
        if (!$a972bfa91f3ae789$var$desktopMediaQuery.matches) {
            prevButton.disabled = true;
            nextButton.disabled = true;
            updateActiveDot();
            return;
        }
        const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
        const currentScroll = Math.round(viewport.scrollLeft);
        prevButton.disabled = currentScroll <= 4;
        nextButton.disabled = currentScroll >= Math.max(0, maxScrollLeft - 4);
        updateActiveDot();
    };
    const getCardStep = ()=>{
        const firstCard = viewport.querySelector(".finance-pillar-card");
        if (!firstCard) return viewport.clientWidth;
        const styles = window.getComputedStyle(viewport.querySelector(".finance-pillar-grid--carousel"));
        const gap = Number.parseFloat(styles.columnGap || styles.gap || "0");
        return firstCard.getBoundingClientRect().width + gap;
    };
    const scrollByCards = (direction)=>{
        if (!$a972bfa91f3ae789$var$desktopMediaQuery.matches) return;
        viewport.scrollBy({
            left: getCardStep() * direction,
            behavior: "smooth"
        });
    };
    prevButton.addEventListener("click", ()=>scrollByCards(-1));
    nextButton.addEventListener("click", ()=>scrollByCards(1));
    viewport.addEventListener("scroll", updateButtons, {
        passive: true
    });
    const handleResize = ()=>{
        if (!$a972bfa91f3ae789$var$desktopMediaQuery.matches) viewport.scrollLeft = 0;
        updateButtons();
    };
    if (typeof $a972bfa91f3ae789$var$desktopMediaQuery.addEventListener === "function") $a972bfa91f3ae789$var$desktopMediaQuery.addEventListener("change", handleResize);
    else $a972bfa91f3ae789$var$desktopMediaQuery.addListener(handleResize);
    window.addEventListener("resize", handleResize, {
        passive: true
    });
    updateButtons();
}
document.querySelectorAll("[data-pillar-carousel]").forEach($a972bfa91f3ae789$var$setupPillarCarousel);
// Se c'e' una bozza del planner salvata su questo dispositivo, le CTA invitano a riprenderla
if ((0, $a7oaJ.loadPlannerDraft)()) document.querySelectorAll('a[href="/check-up-finanziario/wizard"] .button-text').forEach((label)=>{
    label.textContent = "Riprendi il check-up";
});


//# sourceMappingURL=check-up-finanziario.83fbb1db.js.map
